// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15YQj","importantInfo":"styles_importantInfo__3oPnS"};